import React from "react";
import {
  Link,
} from "react-router-dom";
import { withRouter } from 'react-router';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as coupleAction from '../action/coupleAction';


//Material-ui
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartTimeIcon from './PartTimeIcon';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogCoupleRelease: false,
    }
  }
  
  _coupleRequestRelease() {
    this.props.coupleRelease();
  }

  render() {

    if (this.props.notification.couple) {
      let value = this.props.notification.couple;
      return (
        <div className='couple_block'>
          <Box boxShadow={2} style={{background:'#FFF', position:'relative'}} className='round12'>

            <div align='center' style={{padding:'10px'}}>
              <h2>カップリング中</h2>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'center', alignItems:'center', padding:'10px'}}>
                <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                  <PartUserMainImg
                    mainImg={value.userdata_mainImg}
                    width={'50px'}
                    height={'50px'}
                    radius={'50%'}
                  />
                </Link>
                &nbsp;
                <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                  <PartUserName
                    data={{
                      name: value.userdata_name,
                      sex: value.userdata_sex,
                      size: '1.2em',
                    }}
                  />
                </Link>
              </div>
              <div style={{textAlign:'center'}}>
                <PartTimeIcon
                  text={value.userdata_login_aftertime}
                />
              </div>



              <div style={{position:'absolute', top:'0px', right:'0px'}}>
                <IconButton
                  onClick={ (event) => this.setState({
                    coupleRelease: true, coupleReleaseAnchor:event.currentTarget
                  }) }
                >
                  <MoreVertSharpIcon
                    style={{fontSize:'1.2em',color:'#999'}}
                  />
                </IconButton>
              </div>

              <Menu
                anchorEl={this.state.coupleReleaseAnchor}
                keepMounted
                open={(this.state.coupleRelease)? true: false}
                onClick={ () => this.setState({coupleRelease: null}) }
              >
                <MenuItem
                  onClick={ () => {
                    this.props.history.push('/coupleRelease/');
                  }}
                >
                  <div>
                    カップリングを解除
                  </div>
                </MenuItem>
              </Menu>
              <DialogConfirm
                open={ this.state.dialogCoupleRelease }
                title={'カップリングを解除してもいいですか？ '}
                content={
                  <div>
                    <span className="i-b">カップリングを一方的に</span>
                    <span className="i-b">解除すると規約違反となります</span>
                    <span className="i-b">パートナーとお話合いの上</span>
                    <span className="i-b">解除を行ってください</span>
                  </div>
                }
                apply={ () => {
                  this._coupleRequestRelease();
                  this.setState({dialogCoupleRelease: false});
                } }
                close={ () => this.setState({dialogCoupleRelease: false}) }
              />
            </div>
          </Box>
        </div>
      )
    }
    else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
	return {
    notification: state.notification,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...coupleAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
